export const RESET_CUSTOMERS = 'RESET_CUSTOMERS'
export const SET_CUSTOMERS = 'SET_CUSTOMERS'
